
export function needIndexComponent (chartComponent) {
  return !['text', 'borderBlock', 'signName', 'timeClock'].includes(chartComponent)
}
